$('.hide-sticky-bar').click(function(){
    sessionStorage.setItem('sticky' , true);
    document.querySelector('.sticky-add-cart-block').remove();
    document.querySelector('html').classList.remove('has-sticky-bar');
});

const checkSticky = sessionStorage.getItem('sticky');
if(!checkSticky ){
    document.querySelector('.sticky-add-cart-block').style.display = 'block'
    document.addEventListener('DOMContentLoaded', function () {
        checkButtonVisibility(); // Check on page load
      
        // Add event listener for scrolling
        window.addEventListener('scroll', function () {
          checkButtonVisibility(); // Check on scrolling
        });
      });
      
      function checkButtonVisibility() {
        var button = document.getElementById('cta-btn-pf');
      
        if (button) {
          var buttonRect = button.getBoundingClientRect();
      
          if (
            buttonRect.bottom > window.innerHeight ||
            buttonRect.right > window.innerWidth ||
            buttonRect.top < 0 ||
            buttonRect.left < 0
          ) {
            
          document.querySelector('.sticky-add-cart-block').classList.add('shown');
          document.querySelector('html').classList.add('has-sticky-bar');
          } else {
            document.querySelector('.sticky-add-cart-block').classList.remove('shown');
            document.querySelector('html').classList.remove('has-sticky-bar');
          }
        }
      }
    const stickyBtn = document.querySelector('.sticky_bar_add_cart');
stickyBtn.addEventListener('click' , (e) => {
    document.querySelector('#cta-btn-pf').click();
})

$('.mobile-sticky-bar-box-open').click(function(){
  $('.sticky-right-form').addClass('active');
  $('.sticky-mobile-layer').show();
  $('html').addClass('p-no-scroll');
  $('.Product').addClass('Over');
})
$('.sticky-mobile-layer, .close_sticky_right_form ').click(function(){
  $('.sticky-right-form').removeClass('active');
  $('.sticky-mobile-layer').hide();
  $('html').removeClass('p-no-scroll');
  $('.Product').removeClass('Over');
});

$('.sticky-block-right .SwatchButton ').click(function(){
  const targ = $(this).parent().attr('data-swatch-target');
  $(`.ProductForm__Swatches .SwatchItem .SwatchButton`).removeClass('block-selected');
  $(`.ProductForm__Swatches .SwatchItem[data-swatch-target="${targ}"] .SwatchButton`).addClass('block-selected');
  $('.sticky_product_image').attr('src',$(this).parent().find('img').attr('src'))

});
} else{
    document.querySelector('.sticky-add-cart-block').remove();
}

$('.ProductForm__Swatches .SwatchItem .SwatchButton').click(function(){
  const targ = $(this).parent().attr('data-swatch-target');
  $('.sticky-block-right .SwatchButton ').removeClass('block-selected');
  $(`.sticky-block-right  .SwatchItem[data-swatch-target="${targ}"] .SwatchButton`).addClass('block-selected');
  $('.sticky_product_image').attr('src',$(this).parent().find('img').attr('src'))
 
})

/*Contador Visitas*/
if (!customElements.get('visit-count')) {
  class visitCount extends HTMLElement {
    constructor() {
      super();

      this.pid = this.dataset.id;
      this.cookieValue = this.checkCookie();
      if (this.cookieValue != "") {
        this.updateValue();
      } else {
        console.log("EL usuario ya ha visitado el producto");
      }
    }

    checkCookie() {
      let cookieCount = this.getCookie("visitCount");
      let cookieCountValue = "";
        
      if (cookieCount) {
        if (!cookieCount.includes(this.pid)) {
          cookieCountValue = cookieCount + this.pid + ";";
        }
      } else {
        cookieCountValue = this.pid + ";";
      }

      return cookieCountValue;
      
    }

    updateValue() {
      fetch("https://dev.vivaconversion.com/satorisan/visit-count-es.php?pid="+this.pid)
        .then(response => response.json())
        .then((data) => {
          if(data.code == 1) {
            this.setCookie("visitCount", this.cookieValue, 7);
            console.log("Visita aumentada correctamente");
          } else {
            console.log("Error:"+ data.code);
          }
        })
        .catch(error => console.log(error));
    }

    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Días a milisegundos
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
    }

    getCookie(name) {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
          cookie = cookie.trim();
          if (cookie.indexOf(nameEQ) === 0) {
              return decodeURIComponent(cookie.substring(nameEQ.length));
          }
      }
      return null;
    }
      
  }
  
  customElements.define('visit-count', visitCount);
}